
// // 1. this code set by nk

// import React, { createContext, useEffect, useState } from "react";
// import AxiosApi from "../api/AxiosApi";
// import { useNavigate } from "react-router-dom";

// export const BusinessAuthenticationContext = createContext();

// export function BusinessAuthenticationProvider({ children }) {
//     const Navigate = useNavigate();

//     // ✅ LocalStorage se Initial State Set Karna
//     const [IsLoggedIn, setIsLoggedIn] = useState(false);

//     const [LoginLoadingIn, setLoginLoadingIn] = useState(false);
//     const [LoggedInUserInfoIn, setLoggedInUserInfoIn] = useState(false);

//     function userLoginBusiness(LOGIN_ID, PASSWORD, USER_NAME, USER_TYPE) {
//         localStorage.setItem('LOGIN_ID', LOGIN_ID)
//         // localStorage.setItem('PW', PW)
//         setLoginLoadingIn(true);

//         let headersList = {
//             Accept: '/',
//             'Content-Type': 'application/x-www-form-urlencoded',
//         };

//         let bodyContent = `LOGIN_ID=${LOGIN_ID}&PASSWORD=${PASSWORD}&USER_NAME=${USER_NAME}&USER_TYPE=${USER_TYPE}`;

//         AxiosApi.post('CMN_07_Super/SLogin', bodyContent, headersList)
//             .then((res) => {
//                 localStorage.setItem('SS_KEY', res?.data?.SS_KEY);
//                 localStorage.setItem('LoggedInUserInfoIn', JSON.stringify(res?.data));
//                 localStorage.setItem('isLoggedIn', "true");

//                 setLoggedInUserInfoIn(res?.data);
//                 setIsLoggedIn(true);
//                 setLoginLoadingIn(false);

//                 Navigate('/businessDashboard');
//             })
//             .catch(() => {
//                 alert('Invalid Credentials!');
//                 setLoginLoadingIn(false);
//             });
//     }


//     function logOutIn() {
//          localStorage.clear()
//         setLoggedInUserInfoIn(null)
//         setIsLoggedIn(false)
//         Navigate('/login')
//     }


//     //  useEffect(() => {
//     //         const data = localStorage.getItem('LoggedInUserInfoIn')
//     //         const userData = JSON.parse(data)
//     //         if (userData) {
//     //             setIsLoggedIn(true)
//     //             setLoggedInUserInfoIn(userData)
//     //           //  Navigate('/userDashboard')
//     //         } else {
//     //          //   setIsLogged(false)
//     //             setLoggedInUserInfoIn(null)
//     //           //  localStorage.clear()
//     //            // Navigate('login')
//     //         }
//     //     }, [IsLoggedIn])


//     useEffect(() => {
//         const data = localStorage.getItem('LoggedInUserInfoIn');
//         const userData = data ? JSON.parse(data) : null;

//         if (userData) {
//             const loginInfoData = localStorage.getItem("pass");

//             if (loginInfoData === "target") {  // ✅ Use `===` for comparison
//                 setIsLoggedIn(true);
//                 setLoggedInUserInfoIn(userData);
//             } else {
//                 setIsLoggedIn(false);
//                 setLoggedInUserInfoIn(null);


//             }
//         } else {
//             setIsLoggedIn(false);
//             setLoggedInUserInfoIn(null);
//         }
//     }, []); // ✅ Remove `[IsLoggedIn]` to prevent infinite re-renders



//     return (
//         <BusinessAuthenticationContext.Provider value={{ IsLoggedIn, userLoginBusiness, logOutIn, LoginLoadingIn, LoggedInUserInfoIn }}>
//             {children}
//         </BusinessAuthenticationContext.Provider>
//     );
// }








import React, { createContext, useEffect, useState } from "react";
import AxiosApi from "../api/AxiosApi";
import { useNavigate } from "react-router-dom";

export const BusinessAuthenticationContext = createContext();

export function BusinessAuthenticationProvider({ children }) {
    const Navigate = useNavigate();
    
    // ✅ LocalStorage se Initial State Set Karna
    const [IsLoggedIn, setIsLoggedIn] = useState(false);

    const [LoginLoadingIn, setLoginLoadingIn] = useState(false);
    const [LoggedInUserInfoIn, setLoggedInUserInfoIn] = useState(false);
    const [businessAuthLoading, setBusinessAuthLoading] = useState(true);

    function userLoginBusiness(LOGIN_ID, PASSWORD, USER_NAME, USER_TYPE) {
        localStorage.setItem('LOGIN_ID',LOGIN_ID)
        // localStorage.setItem('PW', PW)
        setLoginLoadingIn(true);

        let headersList = {
            Accept: '/',
            'Content-Type': 'application/x-www-form-urlencoded',
        };

        let bodyContent = `LOGIN_ID=${LOGIN_ID}&PASSWORD=${PASSWORD}&USER_NAME=${USER_NAME}&USER_TYPE=${USER_TYPE}`;

        AxiosApi.post('CMN_07_Super/SLogin', bodyContent, headersList)
            .then((res) => {
                localStorage.setItem('SS_KEY', res?.data?.SS_KEY);
                localStorage.setItem('LoggedInUserInfoIn', JSON.stringify(res?.data));
               localStorage.setItem('isLoggedIn', IsLoggedIn);

                setLoggedInUserInfoIn(res?.data);
                setIsLoggedIn(true);
                setLoginLoadingIn(false);

                Navigate('/businessDashboard');
            })
            .catch(() => {
                alert('Invalid Credentials!');
                setLoginLoadingIn(false);
            });
    }

    
    function logOutIn() {
        localStorage.clear()
        setLoggedInUserInfoIn(null)
        setIsLoggedIn(false)

        // setTimeout(() => {
        //     Navigate('/login', { replace: true });  // ✅ Ensure proper navigation
        // }, 0);

        Navigate('/login')
    }


    //  useEffect(() => {
    //         const data = localStorage.getItem('LoggedInUserInfoIn')
    //         const userData = JSON.parse(data)
    //         if (userData) {
    //             setIsLoggedIn(true)
    //             setLoggedInUserInfoIn(userData)
    //           //  Navigate('/userDashboard')
    //         } else {
    //          //   setIsLogged(false)
    //             setLoggedInUserInfoIn(null)
    //           //  localStorage.clear()
    //            // Navigate('login')
    //         }
    //     }, [IsLoggedIn])


    useEffect(() => {
        const data = localStorage.getItem('LoggedInUserInfoIn');
        const userData = data ? JSON.parse(data) : null;
    
        if (userData && localStorage.getItem("pass") === "target") {
            setIsLoggedIn(true);
            setLoggedInUserInfoIn(userData);
        } else {
            setIsLoggedIn(false);
            setLoggedInUserInfoIn(null);
        }
    
        setBusinessAuthLoading(false);  // ✅ Done loading
    }, []);


    return (
        <BusinessAuthenticationContext.Provider value={{ IsLoggedIn, userLoginBusiness, logOutIn, LoginLoadingIn, LoggedInUserInfoIn,businessAuthLoading }}>
            {children}
        </BusinessAuthenticationContext.Provider>
    );
}
